import React from 'react';
import {Alert, Form, Icon, Button, Row, Col, Upload, Select} from 'antd';
import get from 'lodash/get';
import { connect } from 'react-redux';

import { updateSiteSpecimenSampleRequest } from "../../../api/requests";
import {
  getSpecimenSampleCreatePermission,
  getSpecimenSampleUpdatePermission,
  getUserTimezone,
  getUserShortTimezone
} from "../../../reducers/user/selectors";

import classes from './SpecimenSampleEditForm.css';
import { logout } from "../../../reducers/user/actions";
import {withNamespaces} from "react-i18next";

const { Option } = Select;

class SpecimenSampleEditForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
    };
  }

  handleSubmit = e => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        this.setState({ isLoading: true });

        try {
          await updateSiteSpecimenSampleRequest(this.props.specimenSampleEdit.id, values.site_code);

          this.setState({ isLoading: false, requestResult: { type: 'success', message: this.props.i18n.t('Success') } });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, 'response.status') === 401) { this.props.logout();  return; }
          this.setState({ isLoading: false, requestResult: { type: 'error', message: get(e, 'response.data.message', this.props.i18n.t('Error')) } });
        }
      }
    });
  };

  render() {
    const { isLoading, requestResult } = this.state;
    const { getFieldDecorator } = this.props.form;
    const { sitesList } = this.props;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className='headline-default'>
            {this.props.i18n.t("NamespaceSpecimenSample:Edit site")}
          </h4>

          <Row gutter={12}>
            <Col md={12}>
              {getFieldDecorator('site_code', {
                rules: [{ required: true, message: 'Required' }],
                initialValue: get(this.props, 'specimenSampleEdit.siteCode', '')
              })(
                <Select placeholder={this.props.i18n.t('Select Site')}>
                  {sitesList.map(site => (
                    <Option key={site.code} value={site.code}>{site.code} - {site.name}</Option>
                  ))}
                </Select>
              )}
            </Col>
          </Row>

          {requestResult.type && (<Alert message={requestResult.message} type={requestResult.type} className={classes.submitResult} />)}

          <div className={classes.actionWrapper}>
            <Form.Item>
              <Button type="primary" size="large" htmlType="submit" className={classes.submitButton}>
                {this.props.i18n.t("Save")}
                {isLoading && <Icon type="loading" />}
              </Button>&nbsp; &nbsp;
            </Form.Item>

            <Button type="default" size="large" htmlType="button" className={classes.submitButton} onClick={this.props.onCancel}>
              {this.props.i18n.t("Cancel")}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
  specimenSampleCreatePermission: getSpecimenSampleCreatePermission(state),
  specimenSampleUpdatePermission: getSpecimenSampleUpdatePermission(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: 'SpecimenSampleEditForm' })(connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(SpecimenSampleEditForm)));



// WEBPACK FOOTER //
// ./src/containers/SpecimenSampleEditor/SpecimenSampleEditForm/SpecimenSampleEditForm.js